/**
 * vibration.ts — Sprint 3: Feedback tattile su azioni chiave
 *
 * Fornisce pattern di vibrazione predefiniti per dare feedback
 * all'utente su Android (navigator.vibrate).
 * Su iOS e browser senza supporto, la chiamata è no-op.
 */

/** Breve click (10ms) — tap su pulsante */
export function tapFeedback() {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(10);
  }
}

/** Conferma azione (30ms) — invio messaggio, salvataggio */
export function confirmFeedback() {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(30);
  }
}

/** Attenzione (pattern: 50ms, 100ms pausa, 50ms) — errore */
export function warningFeedback() {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate([50, 100, 50]);
  }
}

/** Successo (pattern: 20ms, 50ms pausa, 20ms, 50ms pausa, 60ms) */
export function successFeedback() {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate([20, 50, 20, 50, 60]);
  }
}
